import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaCamera, FaUser, FaSignOutAlt, FaCog, FaMobileAlt } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (!user) return null;

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <Link to="/" className="navbar-brand">
          <FaCamera /> Photo Gallery
        </Link>

        <div className="navbar-menu">
          <Link to="/" className="nav-link">
            Mes Albums
          </Link>
          
          <Link to="/app-tokens" className="nav-link">
            <FaMobileAlt /> App Mobile
          </Link>
          
          {user.is_admin && (
            <Link to="/admin" className="nav-link">
              <FaCog /> Admin
            </Link>
          )}

          <div className="user-menu">
            <FaUser />
            <span>{user.username}</span>
            <button onClick={handleLogout} className="btn-logout">
              <FaSignOutAlt /> Déconnexion
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;